import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingComponent from '../Components/LoadingComponent';
import SuccessfulSignUp from '../Components/SuccessfulSignUp';
import Dashboard from '../Pages/admin/Dashboard/Dashboard';
import Attendance from '../Pages/admin/Events/EventDetails/Attendance';
import Courses from '../Pages/admin/Events/EventDetails/Courses';
import EventDetailsLayout from '../Pages/admin/Events/EventDetails/EventDetailsLayout';
import EventOverview from '../Pages/admin/Events/EventDetails/EventOverview';
import EventParticipants from '../Pages/admin/Events/EventDetails/EventParticipants';
import EventResoucePerson from '../Pages/admin/Events/EventDetails/EventResoucePerson';
import EventSessions from '../Pages/admin/Events/EventDetails/EventSessions';
import PostEventActivities from '../Pages/admin/Events/EventDetails/PostEventActivities';
import EventForm from '../Pages/admin/Events/EventForm';
import Events from '../Pages/admin/Events/Events';
import EventsTable from '../Pages/admin/Events/EventsTable/EventsTable';
import PostEventCreations from '../Pages/admin/Events/Steps/PostEventCreations';
import EventsManager from '../Pages/admin/Events/Steps/EventsManager';
import Notification from '../Pages/admin/Notification/Notification';
import CdAdminTable from '../Pages/admin/Prayogkarta/CD_Admins/CdAdminTable';
import Cd_Admin from '../Pages/admin/Prayogkarta/CD_Admins/Cd_Admin';
import GeneralInfoForm from '../Pages/admin/Prayogkarta/components/GeneralInfoForm';
import New from '../Pages/admin/Prayogkarta/components/New';
import Profile from '../Pages/admin/Prayogkarta/Profile/Profile';
import DevelopmentPartners from '../Pages/admin/Prayogkarta/Development_partners/DevelopmentPartners';
import Executives from '../Pages/admin/Prayogkarta/Executives/Executives';
import ExecutivesTable from '../Pages/admin/Prayogkarta/Executives/ExecutivesTable';
import Trainees from '../Pages/admin/Prayogkarta/Participants/Trainees';
import TraineesList from '../Pages/admin/Prayogkarta/Participants/TraineesList';
import Prayogkarta from '../Pages/admin/Prayogkarta/Prayogkarta';
import PrayogkartaView from '../Pages/admin/Prayogkarta/PrayogkartaView';
import SuperAdmin from '../Pages/admin/Prayogkarta/Super_users/SuperAdmin';
import SuperAdminTable from '../Pages/admin/Prayogkarta/Super_users/SuperAdminTable';
import EventsReport from '../Pages/admin/Report/Events/EventsReport';
import OverAllReport from '../Pages/admin/Report/OverAll/OverAllReport';
import ReportLayout from '../Pages/admin/Report/ReportLayout';
import ApprovalList from '../Pages/admin/Rosters/ApprovalList';
import OrganizationRosterTable from '../Pages/admin/Rosters/OrganizationRosterTable';
import Rosters from '../Pages/admin/Rosters/Rosters';
import SuspendedList from '../Pages/admin/Rosters/SuspendedList';
import EmployeeType from '../Pages/admin/Settings/EmployeeType/EmployeeType';
import SectorType from '../Pages/admin/Settings/SectorType/SectorType';
import Executive from '../Pages/admin/Settings/Executive/Executive';
import FiscalYear from '../Pages/admin/Settings/FiscalYear/FiscalYear';
import OfficeKind from '../Pages/admin/Settings/OfficeKind/OfficeKind';
import Security from '../Pages/admin/Settings/Security/Security';
import UpdatePassword from '../Pages/admin/Settings/Security/UpdatePassword';
import UpdatePin from '../Pages/admin/Settings/Security/UpdatePin';
import Settings from '../Pages/admin/Settings/Settings';
import SettingsView from '../Pages/admin/Settings/SettingView';
import ThematicArea from '../Pages/admin/Settings/ThematicArea/ThematicArea';
import ThematicAreaForm from '../Pages/admin/Settings/ThematicArea/ThematicAreaForm';
import RosterType from '../Pages/auth/Roster/Component/RosterType';
import Individual from '../Pages/auth/Roster/Individual';
import Organization from '../Pages/auth/Roster/Organization';
import IndividualStep0 from '../Pages/auth/Roster/Steps/Individual/IndividualStep0';
import IndividualStep1 from '../Pages/auth/Roster/Steps/Individual/IndividualStep1';
import IndividualStep2 from '../Pages/auth/Roster/Steps/Individual/IndividualStep2';
import IndividualStep3 from '../Pages/auth/Roster/Steps/Individual/IndividualStep3';
import IndividualStep4 from '../Pages/auth/Roster/Steps/Individual/IndividualStep4';
import OrganizationStep0 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep0';
import OrganizationStep1 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep1';
import OrganizationStep2 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep2';
import OrganizationStep3 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep3';
import OrganizationStep4 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep4';
import OrganizationStep5 from '../Pages/auth/Roster/Steps/Organization/OrganizationStep5';
import TraineeStep0 from '../Pages/auth/Trainee/Steps/TraineeStep0';
import TraineeStep1 from '../Pages/auth/Trainee/Steps/TraineeStep1';
import TraineeStep2 from '../Pages/auth/Trainee/Steps/TraineeStep2';
import DefaultCertificateTemplate from '../Pages/admin/Settings/DefaultCertificateTemplate/DefaultCertificateTemplate';
import EventCalendar from '../Pages/admin/EventCalendar/EventCalendar';
import EventSuspend from '../Pages/admin/Events/EventsTable/EventSuspend';
import EventReportType from '../Pages/admin/Report/OverAll/EventReportType';
import EmployeeLevel from '../Pages/admin/Settings/EmployeeType/EmployeeLevel';
import AddEmployeeLevel from '../Pages/admin/Settings/EmployeeType/AddEmployeeLevel';

const EventStep0 = lazy(() => import('../Pages/admin/Events/Steps/EventStep0'));
const EventStep1 = lazy(() => import('../Pages/admin/Events/Steps/EventStep1'));
const EventStep2 = lazy(() => import('../Pages/admin/Events/Steps/EventStep2'));
const EventStep3 = lazy(() => import('../Pages/admin/Events/Steps/EventStep3'));
const EventStep4 = lazy(() => import('../Pages/admin/Events/Steps/EventStep4'));
const EventStep5 = lazy(() => import('../Pages/admin/Events/Steps/EventStep5'));

export default (
  <>
    <Route index exact element={<Dashboard />} />
    <Route path="events" element={<Events />}>
      <Route index element={<EventsTable />}></Route>
      <Route path="new" element={<EventForm />}>
        <Route
          index
          path="0"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep0 />
            </Suspense>
          }></Route>
        <Route
          path="1"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep1 />
            </Suspense>
          }></Route>
        <Route
          path="2"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep2 />
            </Suspense>
          }></Route>
        <Route
          path="3"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep3 />
            </Suspense>
          }></Route>
        <Route
          path="4"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep4 />
            </Suspense>
          }></Route>
        <Route
          path="5"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep5 />
            </Suspense>
          }></Route>
        <Route
          path="6/:id/post_event_create"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <PostEventCreations />
            </Suspense>
          }></Route>
      </Route>
      <Route path=":eventId/edit" element={<EventForm />}>
        <Route
          index
          path="0"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep0 />
            </Suspense>
          }></Route>
        <Route
          path="1"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep1 />
            </Suspense>
          }></Route>
        <Route
          path="2"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep2 />
            </Suspense>
          }></Route>
        <Route
          path="3"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep3 />
            </Suspense>
          }></Route>
        <Route
          path="4"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep4 />
            </Suspense>
          }></Route>
        <Route
          path="5"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventStep5 />
            </Suspense>
          }></Route>
        <Route
          path="event_managers"
          element={
            <Suspense fallback={<LoadingComponent />}>
              <EventsManager />
            </Suspense>
          }></Route>
      </Route>
      <Route path="suspended" element={<EventSuspend />}></Route>
      <Route path=":id" element={<EventDetailsLayout />}>
        <Route index element={<EventOverview />}></Route>
        <Route path="participants" element={<EventParticipants />}></Route>
        <Route path="roster" element={<EventResoucePerson />}></Route>
        <Route path="event_sessions" element={<EventSessions />}></Route>
        <Route path="attendence" element={<Attendance />}></Route>
        <Route path="documents" element={<Attendance />}></Route>
        <Route path="courses" element={<Courses />}></Route>
        <Route path="edit_managers" element={<EventsManager />}></Route>
        <Route path="post_event_activity" element={<PostEventActivities />}></Route>
      </Route>
      {/* 'प्रश्नहरू थप्नुहोस्', 'Post Event Activity' */}
    </Route>
    <Route path="calendar" element={<EventCalendar />}></Route>
    {/* =============================Routes for settings===================================== */}
    <Route path="settings" element={<Settings />}>
      <Route index element={<SettingsView />}></Route>
      <Route path="thematic_area" element={<ThematicArea />}></Route>
      <Route path="thematic_area/new" element={<New />}>
        <Route index element={<ThematicAreaForm />}></Route>
      </Route>
      <Route path="thematic_area/:id/:edit" element={<ThematicAreaForm />}></Route>
      <Route path="expected_executive" element={<Executive />}></Route>
      <Route path="office_kind" element={<OfficeKind />}>
        <Route path=":id/:edit/" element={<OfficeKind />}></Route>
      </Route>
      <Route path="employee_type" element={<EmployeeType />}>
        <Route path=":id/:edit/" element={<EmployeeType />}></Route>
      </Route>
      <Route path="employee_type_level/" element={<EmployeeLevel />} />
      <Route path="employee_type_level/add/" element={<AddEmployeeLevel />}></Route>
      <Route path="employee_type_level/:id/edit" element={<AddEmployeeLevel />}></Route>

      <Route path="sector_type" element={<SectorType />}>
        <Route path=":id/:edit/" element={<SectorType />}></Route>
      </Route>
      <Route path="fiscal_year" element={<FiscalYear />}></Route>
      <Route path="security" element={<Security />}>
        <Route index path={'update-password'} element={<UpdatePassword />}></Route>
        <Route path={'update-pin'} element={<UpdatePin />}></Route>
      </Route>
      <Route path="certificate_template" element={<DefaultCertificateTemplate />}></Route>
    </Route>
    {/* ==================================Routes for Rosters=================================== */}
    <Route path="rosters/individual_list" element={<New />}>
      <Route index element={<Rosters />}></Route>
    </Route>

    <Route path="rosters/profile/:id" element={<Profile profileType="resource-person" />}></Route>
    <Route path="profile/:me" element={<Profile profileType="me" />}></Route>
    <Route path="rosters/organization_list" element={<New />}>
      <Route index element={<OrganizationRosterTable />}></Route>
    </Route>
    <Route path="rosters/individual_apply" element={<Individual />}>
      <Route index element={<IndividualStep0 />}></Route>
      <Route path="1" element={<IndividualStep1 />}></Route>
      <Route path="2" element={<IndividualStep2 />}></Route>
      <Route path="3" element={<IndividualStep3 />}></Route>
      <Route path="4" element={<IndividualStep4 />}></Route>
    </Route>

    <Route path="rosters/individual/:id/:edit" element={<Individual />}>
      <Route index element={<IndividualStep0 />}></Route>
      <Route path="1" element={<IndividualStep1 />}></Route>
      <Route path="2" element={<IndividualStep2 />}></Route>
      <Route path="3" element={<IndividualStep3 />}></Route>
      <Route path="4" element={<IndividualStep4 />}></Route>
    </Route>

    <Route path="/admin/instructions/:type/:email" element={<SuccessfulSignUp />}></Route>

    <Route path="/admin/notifications" element={<Notification />}></Route>

    <Route path="rosters/choose_type" element={<RosterType />}>
      {/* <Route index element={< />}></Route> */}
    </Route>
    <Route path="rosters/organization/:id/:edit" element={<Organization />}>
      <Route index element={<OrganizationStep0 />}></Route>
      <Route path="1" element={<OrganizationStep1 />}></Route>
      <Route path="2" element={<OrganizationStep2 />}></Route>
      <Route path="3" element={<OrganizationStep3 />}></Route>
      <Route path="4" element={<OrganizationStep4 />}></Route>
      <Route path="5" element={<OrganizationStep5 />}></Route>
    </Route>

    <Route path="trainees/:id/:edit" element={<Trainees />}>
      <Route index element={<TraineeStep0 />}></Route>
      <Route path="1" element={<TraineeStep1 />}></Route>
      <Route path="2" element={<TraineeStep2 />}></Route>
    </Route>

    <Route path="rosters/organization_apply" element={<Organization />}>
      <Route index element={<OrganizationStep0 />}></Route>
      <Route path="1" element={<OrganizationStep1 />}></Route>
      <Route path="2" element={<OrganizationStep2 />}></Route>
      <Route path="3" element={<OrganizationStep3 />}></Route>
      <Route path="4" element={<OrganizationStep4 />}></Route>
      <Route path="5" element={<OrganizationStep5 />}></Route>
    </Route>
    <Route path="rosters/suspended_list" element={<SuspendedList />}></Route>

    <Route path="rosters/request_approval" element={<ApprovalList />}></Route>

    <Route
      path="rosters/choose_type"
      element={
        <div className="card bg-white">
          <RosterType />
        </div>
      }>
      {/* <Route index element={< />}></Route> */}
    </Route>
    {/* <Route path="rosters/individual_apply" element={<New />}>
      <Route index element={< />}></Route>
    </Route> */}

    {/* ======================================================================================= */}
    <Route path="report" element={<ReportLayout />}>
      <Route index path="overall" element={<OverAllReport />}></Route>

      <Route path="events" element={<EventsReport />}></Route>
    </Route>
    <Route path="report/overall/:type" element={<EventReportType />}></Route>

    {/* ===================================================================================== */}
    {/* ===================================User Routes here================================== */}
    <Route path="users" element={<Prayogkarta />}>
      <Route index element={<PrayogkartaView />}></Route>
      <Route path="super_users" element={<SuperAdmin />}>
        <Route index element={<SuperAdminTable />}></Route>
        <Route
          path="new"
          element={
            <GeneralInfoForm userType={'super_admin'} url={'/profile/superuser/'} />
          }></Route>
        <Route
          path=":edit/:id"
          element={
            <GeneralInfoForm userType={'super_admin'} url={'/profile/superuser/'} />
          }></Route>
        <Route path="profile/:id" element={<Profile profileType="superuser" />}></Route>
      </Route>

      <Route path="cd_admins" element={<Cd_Admin />}>
        <Route index element={<CdAdminTable />}></Route>
        <Route
          path="new"
          element={<GeneralInfoForm userType={'cd_admin'} url={'/profile/cd-admin/'} />}></Route>
        <Route
          path=":edit/:id"
          element={<GeneralInfoForm userType={'cd_admin'} url={'/profile/cd-admin/'} />}></Route>
        <Route path="profile/:id" element={<Profile profileType="cd-admin" />}></Route>
      </Route>
      <Route path="executives" element={<Executives />}>
        <Route index element={<ExecutivesTable />}></Route>
        <Route
          path="new"
          element={<GeneralInfoForm userType={'executive'} url={'/profile/executive/'} />}></Route>
        <Route
          path=":edit/:id"
          element={<GeneralInfoForm userType={'executive'} url={'/profile/executive/'} />}></Route>
        <Route path="profile/:id" element={<Profile profileType="executive" />}></Route>
      </Route>

      <Route path="trainees/" element={<Trainees />}>
        <Route path="list" element={<TraineesList />}></Route>
        <Route index element={<TraineeStep0 />}></Route>
        <Route path="1" element={<TraineeStep1 />}></Route>
        <Route path="2" element={<TraineeStep2 />}></Route>
      </Route>
      <Route path="trainees/profile/:id" element={<Profile profileType="participant" />}></Route>

      <Route path="development_partners" element={<DevelopmentPartners />}></Route>
    </Route>

    {/* ========================================================================================= */}
    {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
    {/* <Route path="*" element={<NoMatch />} /> */}
  </>
);
